<template>
  <div class="kpi-type-card">
    <div class="kpi-header">
      <span class="kpi-title">{{ title }}</span>

      <span v-if="info" class="kpi-info-wrapper">
        <v-icon small class="kpi-info">mdi-information-outline</v-icon>
        <span class="kpi-tooltip" v-if="infoText">{{ infoText }}</span>
      </span>
    </div>

    <div class="kpi-lines">
      <div class="kpi-line">
        <span class="kpi-label">Água:</span>
        <span class="kpi-value">{{ water }}</span>
      </div>

      <div class="kpi-line">
        <span class="kpi-label">Esgoto:</span>
        <span class="kpi-value">{{ sewer }}</span>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "KpiTypeCard",
  props: {
    title: {
      type: String,
      required: true
    },
    water: {
      type: String,
      required: true
    },
    sewer: {
      type: String,
      required: true
    },
    info: {
      type: Boolean,
      default: true
    },
    infoText: {
      type: String,
      default: ""
    }
  }
}
</script>

<style scoped>
.kpi-type-card {
  background: #f2f6ff;
  border: 1.5px solid #e0e3ea;
  border-radius: 12px;
  padding: 14px 16px;
  min-width: 200px;
  min-height: 70px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.kpi-header {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.kpi-title {
  color: #545454;
  font-size: 12px;
  font-weight: 500;
  margin-right: 6px;
  line-height: 1.1;
}

.kpi-info-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.kpi-info {
  font-size: 12px;
  color: #545454;
}

.kpi-tooltip {
  display: none;
  min-width: 150px;
  position: absolute;
  left: 50%;
  top: 120%;
  transform: translateX(-50%);
  background: #001532;
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  font-size: 12px;
  white-space: pre-line;
  z-index: 1000;
}

.kpi-info-wrapper:hover .kpi-tooltip {
  display: block;
}

.kpi-lines {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.kpi-line {
  display: flex;
  
  font-size: 0.7rem;
  line-height: 1.2;
}

.kpi-label {
  color: #545454;
  margin-right: 5px;
  font-weight: 500;
}

.kpi-value {
  color: #1c1c1c;
  font-weight: 600;
}
</style>
